import React from 'react';
import { HorizontalBarChart } from '../../../../components/charts/horizontal-bar-chart/horizontal-bar-chart';
import { EmptyState } from '../../../../components/general/empty-state/empty-state';
import { IRoleFitContentProps } from './role-fit-content.models';
import { AstronautLoader } from '../../../../components/general/loading-state/loaders/astronaut-loader/astronaut-loader';
import { WidgetCard } from '../../analytics-filters/widget-card';

export function RoleFitContent({ title, subtitle, roleSlug, peopleSlugs, isLoading, data, fill }: IRoleFitContentProps): React.ReactElement {
  function renderContent() {
    if (!roleSlug) return <EmptyState title="Please select a role" />;

    if (!peopleSlugs.length) return <EmptyState title="Please select at least one person" />;

    if (!data?.length) return <EmptyState />;

    return <HorizontalBarChart dataPoints={data} fill={fill} showLegend />;
  }

  return (
    <WidgetCard title={title} subtitle={subtitle}>
      {isLoading ? <AstronautLoader /> : renderContent()}
    </WidgetCard>
  );
}
